<template>
  <div>
    <faq-search :search="search" @update-search="updateSearch" />
    <faq-list
      :openQuestions="openQuestions"
      :questions="filteredQuestions"
      :search="search"
    />
  </div>
</template>

<script>
import FaqSearch from "./FaqSearch.vue";
import FaqList from "./FaqList.vue";
export default {
  name: "FaqWrap",
  components: { FaqSearch, FaqList },
  props: ["faq"],
  data() {
    return {
      search: "",
    };
  },
  computed: {
    openQuestions() {
      if (!this.search) {
        return this.faq;
      }

      const openQuestions = [];

      this.faq.forEach((question, index) => {
        const includes =
          question.title.includes(this.search) ||
          question.subtitle.includes(this.search) ||
          question.editor.includes(this.search);

        question?.inner_level?.forEach((inner, indexInner) => {
          const includesInner =
            inner.inner_title.includes(this.search) ||
            inner.editor.includes(this.search);

          if (includesInner) {
            openQuestions.push(`${index}_${indexInner}`);
          }
        });

        if (includes) {
          openQuestions.push(index);
        }
      });

      return openQuestions;
    },
    filteredQuestions() {
      if (!this.search) {
        return this.faq;
      }

      const faqs = this.faq.map((question, index) => {
        const includes =
          question.title.includes(this.search) ||
          question.subtitle.includes(this.search) ||
          question.editor.includes(this.search) ||
          question?.inner_level?.find(
            (inner) =>
              inner.inner_title.includes(this.search) ||
              inner.editor.includes(this.search)
          );

        question.inner_level =
          question?.inner_level?.map((inner, indexInner) => {
            const includesInner =
              inner.inner_title.includes(this.search) ||
              inner.editor.includes(this.search);

            inner.original_index = `${index}_${indexInner}`;

            return inner;
          }) ?? [];

        console.log("inner level");
        console.log(question.inner_level);

        question.original_index = index;

        return includes ? question : null;
      });

      return faqs.filter((faq) => faq);
    },
  },
  methods: {
    updateSearch(val) {
      this.search = val;
    },
  },
};
</script>
